import { render, staticRenderFns } from "./OrgErrorMessage.vue?vue&type=template&id=51c95f0b&scoped=true&"
import script from "./OrgErrorMessage.vue?vue&type=script&lang=ts&"
export * from "./OrgErrorMessage.vue?vue&type=script&lang=ts&"
import style0 from "./OrgErrorMessage.vue?vue&type=style&index=0&id=51c95f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c95f0b",
  null
  
)

export default component.exports